// @flow
import * as React from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { ActivityIndicator } from 'trpc-react-native-ui';
import { OptionSlider } from '../common/CharacteristicSlider';
import { hasNoUnlimitedOptionChoice } from '../common/CharacteristicSlider/lib/hasUnlimitedOptionChoice';
import { isEmpty } from 'lodash';

const TopUpSliders = (props: Props) => {
  if (props.isLoading && isEmpty(props.availableTopUps)) {
    return (
      <View style={styles.emptyView}>
        <ActivityIndicator />
      </View>
    );
  }

  const availableTopUps = (Object.entries(props.availableTopUps): any).map(([type, topUps]) => [
    type,
    [
      {
        characteristics: [
          {
            unit: topUps[0].characteristics[0].unit,
            value: 0,
          },
        ],
        id: '',
        periodicity: {
          number: 0,
          type: 'MONTH',
        },
        price: 0,
        type,
      },
      ...topUps,
    ],
  ]);

  const smallBubble = hasNoUnlimitedOptionChoice(Object.values(props.availableTopUps));

  return (
    <ScrollView testID="topup-amount-list" contentContainerStyle={styles.scrollViewContent}>
      {availableTopUps.map(([unitType, topUps], currentAvailableTopUpIndex) => {
        const numberOfSliders = currentAvailableTopUpIndex + 1;
        const withSeparator = numberOfSliders !== availableTopUps.length && props.withSecondaryRow;

        return (
          <OptionSlider
            key={unitType}
            testID={`topup-amount-item-${currentAvailableTopUpIndex}`}
            sliderTestID={`topup-slider-${currentAvailableTopUpIndex}`}
            name={unitType}
            onSelect={props.addTopUpToSelection}
            optionRowInfos={props.optionRowInfos}
            options={topUps}
            priceKey={props.priceKey}
            selectedOptions={props.selectedTopUps}
            smallBubble={smallBubble}
            withSeparator={withSeparator}
            withZoneValidity={props.withZoneValidity}
          />
        );
      })}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  emptyView: {
    flex: 1,
    justifyContent: 'center',
  },
  scrollViewContent: {
    paddingVertical: 20,
  },
});

type Props = {
  addTopUpToSelection: Function,
  availableTopUps: { [string]: Object[] },
  isLoading: boolean,
  optionRowInfos: {
    availableTopUps?: { [string]: Object[] },
    getSelectedVoiceTopUp: ?Function,
    selectedTopUps: Object[],
    travelZone: ?string,
  },
  priceKey: string,
  selectedTopUps: Object[],
  withSecondaryRow: ?boolean,
  withZoneValidity?: boolean,
};

export default TopUpSliders;
